enum localStorageEnum {
	offre_courante = 'offre_courante',
	client_courant = 'client_courant',
	accessToken = 'accessToken'
}

export default localStorageEnum